import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { API_REQUEST } from '@/api/';
import { getCorrectShiftWorkEndTime } from '@/modules/time-table';
import rollbackWorkerDays from "./common/rollbackWorkerDays";
export default /*#__PURE__*/(function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var commit, dispatch, requestData, apiMethod, _yield$API_REQUEST, _yield$API_REQUEST2, data, dayId;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, dispatch = _ref.dispatch;
            requestData = _ref2.requestData, apiMethod = _ref2.apiMethod;
            requestData.dttm_work_end = getCorrectShiftWorkEndTime(requestData);
            _context.next = 5;
            return API_REQUEST(apiMethod, requestData);

          case 5:
            _yield$API_REQUEST = _context.sent;
            _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
            data = _yield$API_REQUEST2[1];

            if (data) {
              dayId = requestData.dt + '_' + requestData.worker_id;
              rollbackWorkerDays.set(dayId, 0, requestData);
              commit('increaseCoverageDataRefresh');
              commit('clearDayInEditing'); // if (apiMethod === 'updateWorkerDay') {
              //   await dispatch('exchange/replaceVacancy', data, { root: true })
              // }
            }

            return _context.abrupt("return", !!data);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
})();